(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("oriented-image-collection", [], factory);
	else if(typeof exports === 'object')
		exports["oriented-image-collection"] = factory();
	else
		root["oriented-image-collection"] = factory();
})(self, function() {
return 